export class FormValidationException extends Error {
	constructor() {
		super('The following fields are required:');
	}
}

export class ApiResponseErrorException extends Error {
	constructor(res) {
		super('An error of type 1 has occurred. Please try again.');
		this.res = res;
	}
}
